module.exports = __webpack_public_path__ + "img/anli7.80ede194.png";